import { createFileRoute } from "@tanstack/react-router";
import { PersonalSection } from "@/components/personal/personal-section";

export const Route = createFileRoute("/personal")({
	component: PersonalSection,
});
